import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductMaskInput,
    DeleteProductMaskInput,
    ProductMask,
    UpdateProductMaskInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ProductMaskService {
    private amplifyClient = generateClient();

    async getProductMask(id: string): Promise<ProductMask> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductMask,
                    variables: {
                        id
                    }
                })
            ).data.getProductMask;
            if (data) return data as ProductMask;
        } catch (error) {
            console.error('Error finding ProductMask:', error);
            return null;
        }
    }

    async listProductMasks(): Promise<ProductMask[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductMasks
                })
            ).data.listProductMasks.items;
            if (data) return data as ProductMask[];
        } catch (error) {
            console.error('Error finding ProductMask:', error);
            return null;
        }
    }

    async createProductMask(
        input: CreateProductMaskInput
    ): Promise<ProductMask> {
        try {
            const ProductMask = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductMask,
                    variables: {
                        input
                    }
                })
            ).data.createProductMask;
            if (ProductMask) return ProductMask as ProductMask;
        } catch (error) {
            console.error('Error creating ProductMask:', error);
            return null;
        }
    }

    async updateProductMask(
        input: UpdateProductMaskInput
    ): Promise<ProductMask> {
        try {
            const ProductMask = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductMask,
                    variables: {
                        input
                    }
                })
            ).data.updateProductMask;
            if (ProductMask) return ProductMask as ProductMask;
        } catch (error) {
            console.error('Error updating ProductMask:', error);
            return null;
        }
    }

    async deleteProductMask(
        input: DeleteProductMaskInput
    ): Promise<ProductMask> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProductMask,
                    variables: {
                        input
                    }
                })
            ).data.deleteProductMask;
            if (date) return date as ProductMask;
        } catch (error) {
            console.error('Error creating ProductMask:', error);
            return null;
        }
    }

    async productMasksByProductId(productId: string): Promise<ProductMask[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductMasksByProductId,
                    variables: {
                        productId
                    }
                })
            ).data.ProductMasksByProductId.items;
            if (data) return data as ProductMask[];
        } catch (error) {
            console.error('Error finding ProductMask:', error);
            return null;
        }
    }

    async productMasksByCategoryId(categoryId: string): Promise<ProductMask[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductMasksByCategoryId,
                    variables: {
                        categoryId
                    }
                })
            ).data.ProductMasksByCategoryId.items;
            if (data) return data as ProductMask[];
        } catch (error) {
            console.error('Error finding ProductMask:', error);
            return null;
        }
    }
}
